import { combineReducers } from "redux";
import errorReducer from "./errorReducer";
import gameReducer from "./gameReducer";
import serviceReducer from "./serviceReducer";
import reportReducer from "./reportReducer";
import eventReducer from "./eventReducer";
import vipReducer from "./vipReducer";
import faqReducer from "./faqReducer";
import vipServiceReducer from "./serviceVipReducer";
import vipReportReducer from "./reportVipReducer";

export default combineReducers({
  errors: errorReducer,
  games: gameReducer,
  service: serviceReducer,
  report: reportReducer,
  event: eventReducer,
  vip: vipReducer,
  faq: faqReducer,
  vipService: vipServiceReducer,
  vipReport: vipReportReducer,
});
